import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
    selector: 'pr-form-input-select',
    templateUrl: './pr-form-input-select.component.html',
    styleUrls: ['./pr-form-input-select.component.scss'],
    standalone: false
})
export class PrFormInputSelectComponent implements OnInit, AfterViewInit {
  @Output() update: EventEmitter<any> = new EventEmitter();
  @Input() items = [];
  @Input() optionLabel: TemplateRef<any>;
  @ViewChild('defaultOptionLabelTemplate')
  defaultOptionLabelTemplate: TemplateRef<any>;
  @Input() value = '';
  _value = '';

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => (this._value = this.value), 0);
  }

  updateValue($event) {
    this.value = $event.value;
    this.update.emit();
  }

  getTemplate() {
    return this.optionLabel
      ? this.optionLabel
      : this.defaultOptionLabelTemplate;
  }
}
